export class CodeError {
    public static readonly ERROR_500 = 500;
    public static readonly ERROR_400 = 400;
}
